export default "__VITE_ASSET__Qus71Rpa__"